import { render, staticRenderFns } from "./SelectGeneralProblemCurriculumUnit.vue?vue&type=template&id=38217069&scoped=true&lang=pug&"
import script from "./SelectGeneralProblemCurriculumUnit.vue?vue&type=script&lang=ts&"
export * from "./SelectGeneralProblemCurriculumUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38217069",
  null
  
)

export default component.exports